<template>
  <v-container>
    <ComponentPicker v-model="value.component" title="Component" :containers="containers" :is-required="true" />
  </v-container>
</template>

<script>
import ComponentPicker from "../shared/ComponentPicker.vue";

export default {
  name: "EnableDesigner",
  
  components: { ComponentPicker },

  props: ["value", "containers"]
};
</script>
